<template>
  <div>
    <div class="bannerStyle">
      <img src="@/assets/enterprisea.jpg" />
      <img src="@/assets/enterpriseb.jpg" />
      <img src="@/assets/enterprisec.jpg" />
    </div>
    <div class="enter">
      <p class="p"><el-link href="/" :underline="false">首页</el-link> / 企业介绍</p>
      <dl>
        <dt class="floatLeft"><img src="@/assets/banner3.jpg" style="width:474px;" /></dt>
        <dd class="floatRight">
          <p class="triducep1 triducep3">
            “德心合”集团坚持以人为本的服务理念，致力于深入研究和解决人体所处的“第三状态”（Sub-health
            condition），即常被界定为的亚健康状态。我们的团队汇集了一流的专家，利用前沿的科学研究方法，为人们在日常生活中遇到的身体和心理健康问题提供专业解决方案。</p>
          <p class="triducep2">
            <span></span>
          </p>
          <p class="triducep3" v-for="item in txtList">{{item}}</p>
          <p style="margin:15px 0;"></p>
          <p class="triducep3" v-for="item in labelList">{{item}}</p>
        </dd>
      </dl>
    </div>
    <div class="enterImg">
      <img v-for="(item, index) in imgList" :key="index" :src="item" />
    </div>
  </div>
</template>
<style scoped>
  .enterImg {
    margin-top: 50px;
  }

  .enterImg img {
    width: 100%;
    display: block;
  }

  .enter {
    width: 950px;
    margin: auto;
    display: table;
  }

  .enter .p {
    font-size: 14px;
    padding: 30px 0;
  }

  .enter .p a {
    font-size: 14px;
  }

  .enter .floatRight {
    width: 420px;
    padding-top: 30px;
  }

  .triducep1 {
    text-indent: 20px;
  }

  .triducep2 span {
    display: block;
    height: 5px;
    width: 26px;
    background: #707070;
    margin: 20px 0;
  }

  .triducep3 {
    font-size: 14px;
    line-height: 24px;
    color: #707070;
  }
</style>
<script>
  export default {
    data() {
      return {
        txtList: [
          "德心合(北京)健康管理集团 ",
          "德心合(上海) 心理咨询有限公司 ",
          "德心合(杭州) 心理咨询有限公司 ",
          "德心合(江苏) 心理咨询有限公司 ",
          "德心合(厦门) 心理咨询有限公司 ",
          "德心合(深圳) 心理咨询有限公司 ",
          "德心合(香港) 心理咨询有限公司（ 筹建中） "
        ],
        labelList: [
          "德心合(洛杉矶)心理咨询有限公司 ",
          "德心合(伦敦) 心理咨询有限公司 ",
          "德心合(悉尼) 心理咨询有限公司 ",
          "德心合(奥克兰) 心理咨询有限公司 "
        ],
        imgList: [
          require('@/assets/enter1.jpg'),
          require('@/assets/enter2.jpg'),
          require('@/assets/enter3.jpg'),
          require('@/assets/enter4.jpg')
        ],
      }
    },
    created() {
      const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentPosition > 0) {
        // 如果当前位置不为零，则执行滚动操作
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
    },
    methods: {},
  }
</script>



// WEBPACK FOOTER //
// src/components/enterpriseIntroduce.vue